import * as React from "react"
import { Button } from "@/components/ui/button"
import { Plus } from "lucide-react"
import { useBookingT } from "@/hooks/use-translations"

type Props = {
  onRequestIntegration: () => void
}

export function HeroSection({ onRequestIntegration }: Props) {
  const t = useBookingT()
  return (
    <div className="rounded-lg bg-gradient-to-br from-brand-50 to-white">
      <div className="flex flex-col gap-4 max-md:items-stretch md:flex-row md:items-center md:justify-between">
        <div className="space-y-1.5 max-w-2xl">
          <h1 className="text-2xl font-semibold text-neutral-900">
            {t("integrations_hero_title", "Connect TravelCode with the tools you already use")}
          </h1>
          <p className="text-sm text-neutral-700">
            {t(
              "integrations_hero_subtitle",
              "Link your existing systems to automate workflows and share data",
            )}
          </p>
        </div>
        <Button onClick={onRequestIntegration} variant="outline" className="shrink-0">
          <Plus className="size-4" />
          {t("integrations_btn_request", "Request integration")}
        </Button>
      </div>
    </div>
  )
}
